module.exports = __webpack_public_path__ + "static/kazeem-ajani-b4234555f5ffb9c31d80a5d2d2a278ab.jpg";